(function() {
    
    var loadTeasers = function () {

        var teaserFlag = false;
        var $Loader = $('<div>').addClass('teaser--loader');
        var $loader;
        
        var checkProgress = function() {
            
            $('.teasers [data-more]').each(function(){
                
                if (( $(window).scrollTop() + $(window).height() + 10) >= $(document).height()) {
                    if (!teaserFlag && !(typeof($('.teaser').last().data('more'))=='undefined')) {
                        $.ajax({
                            url: $('.teaser').last().data('more'),
                            beforeSend: function () {
                                $loader = $Loader.insertAfter($('.teasers'));
                                teaserFlag = true;
                            },
                            error: function(){
                            },
                            success: function (html) {
                                setTimeout(function(){
                                $loader.remove(); 
                                
                                $(html)
                                    .insertAfter($('.teasers [data-more]').last());

                                teaserFlag = false;
                                if (!$('.__js_teaserLoad').last().data('more')) {
                                    return;
                                }}
                                , 500);
                            }

                        });
                    }
                }

            });
            setTimeout(checkProgress, 450);
        };

        setTimeout(checkProgress, 500);
    };
    if ($('.__js_teaserLoad').length ) {
        loadTeasers();
    }

})();
